/**
 * The fixed system teams, mirroring the backend context's `domain/constants/teams.js`, which owns
 * them; `backendContract.test.js` pins the two. Ids, never names: a name is resolved where it shows.
 */
export const TEAMS = {
  CLINICAL: 'clinical',
  BILLING: 'billing',
  SCHEDULING: 'scheduling',
  INTAKE: 'intake',
  CREDENTIALING: 'credentialing',
};

export const TEAM_IDS = Object.values(TEAMS);

/** The teams a user is on until somebody says otherwise, by access role. */
export const DEFAULT_TEAMS_BY_ROLE = {
  manager: TEAM_IDS,
  administrator: [TEAMS.BILLING, TEAMS.INTAKE, TEAMS.SCHEDULING, TEAMS.CREDENTIALING],
  supervisor: [TEAMS.CLINICAL],
  senior_therapist: [TEAMS.CLINICAL],
  trainer: [TEAMS.CLINICAL],
  parent: [],
};
